export const Constants = {
  SHAREPOINT_URL: "https://cop.kairhos.com/",
  DEBOUNCE_TIME: 500,
} as const;
